var $ = jQuery.noConflict();

function re_captcha_submit(){
    grecaptcha.execute();
}

function form_submit(token){
  jQuery("#g-recaptcha").closest("form").submit();
}

//global function
window.form_submit = form_submit;

function reset_focus(){
    jQuery('.form .form-group.select').removeClass('focus');
}

function init_select(){
  $("select").select2({
    allowClear: true,
    language: "sk"
  }); 
}

jQuery(document).ready(function(){

  add_repeater_button();
  init_select();

  jQuery(".recaptcha.submit").click(function(){
    re_captcha_submit();
  }); 

  $(".submit").click(function(e){
    e.preventDefault();

    $(this).closest("form").submit();
  });

  //datetime picker
  /*
  jQuery('.form .datetime input').datetimepicker({
    locale: 'sk',
    format: 'DD.MM.YYYY'
  });
  */

  //tooltip
  jQuery('[data-toggle="tooltip"]').tooltip();

  //select
  jQuery('select').on('chosen:ready', function (e) {
    if(jQuery(e.target).val() != ""){
      jQuery(e.target).closest('.form-group').addClass('used');
    }
    else{
      jQuery(e.target).closest('.form-group').removeClass('used');
    }
  });
 
  //focus select
  //blur select
  jQuery(document).on('change', 'select', function(e) {
    if(jQuery(e.target).val() != ""){
      jQuery(e.target).closest('.form-group').addClass('used');
    }
    else{
      jQuery(e.target).closest('.form-group').removeClass('used');
    }
  });

  //focus
  jQuery(document).on('focus','.form input[type=text]:not(".select2-search__field"), .form input[type=email], .form textarea', function(event){
    reset_focus();
    jQuery(this).closest('.form-group').addClass('used').addClass('focus');
  });

  //blur
  jQuery(document).on('blur','.form input[type=text], .form input[type=email], .form textarea', function(event){

    jQuery(this).closest('.form-group').removeClass('focus');
    //remove if not set value
    if(jQuery(this).val() == ""){
      jQuery(this).closest('.form-group').removeClass('used');
    }

  });

  jQuery(document).on('click','.form .radio-input', function(event){
    jQuery(this).find('input').attr('checked', true);
  });

  jQuery(document).on('click','.form .checkbox input', function(event){

    if(jQuery(this).closest('.checkbox').hasClass("checked")){
      jQuery(this).removeAttr('checked');
      jQuery(this).closest('.checkbox').removeClass("checked");
      jQuery(this).val('');
    }
    else{
      jQuery(this).closest('.checkbox').addClass("checked");
      jQuery(this).attr('checked', true);
      jQuery(this).val('1');
    }
    
  });

  jQuery('.form select').on('select2:open', function (event) {

    reset_focus();

    jQuery(this).focus();
    jQuery(this).closest('.form-group').addClass('focus').addClass('used');

  });

  jQuery('.form select').on('select2:close', function (event) {

    var data = event.target.value;
    if(data == ""){
      jQuery(this).closest('.form-group').removeClass('used');
    }

  });

  jQuery(window).click(function(){
    reset_focus();
  });

  /*
  jQuery('input, textarea, .select2').click(function(event){
    event.stopPropagation();
  });
  */

});

form_validation_error = function($form_element, errors){
  $form_element.find('.alert.error').show();
  form_mark_invalid_fields($form_element, errors);
  //scroll_to_form_alert($form_element);
}

form_clear_invalid_fields = function($form_element){
  $form_element.find('.alert').hide();
  $form_element.find('.validation-error').removeClass('validation-error');
  $form_element.find('.validation-message').remove();
}

// mark invalid fields
form_mark_invalid_fields = function($form_element, errors){
  
  var keys = Object.keys(errors);

  for(var x=0; x < keys.length; x++){
    var key = keys[x];
    var value_object = errors[key];
    var value = Object.values(value_object)[0];

    $form_element.find('input[name="'+key+'"], select[name="'+key+'"], textarea[name="'+key+'"]').each(function(){
      jQuery(this).closest('.form-group').addClass('validation-error');
      jQuery(this).closest('.form-group').append('<div class="validation-message">'+value+'</div>');
    });
  }
}

scroll_to_form_alert = function(el){
  jQuery("html, body").animate({ scrollTop: el.find('.alert').offset().top - 150 }, 300);
}

scroll_to_form_top = function(){
  jQuery("html, body").animate({ scrollTop: $('form').offset().top - 150 }, 300);
}

// add repeater button
add_repeater_button = function(){
  jQuery(".ge_repeater").append('<div class="btn ge_add_repeater_item" data-toggle="tooltip" data-placement="top" title="Pridať položku"><i class="fas fa-plus-circle"></i></div>');
}

// add repeater element
jQuery(document).on('click', '.ge_add_repeater_item' , function (e) {

  var newItem = $(this).closest('.ge_repeater').find('.ge_template').clone().removeClass('ge_template').removeClass('d-none');
  $(this).before(newItem);
  newItem.find('.ge_remove_repeater_item').removeClass('disabled');

  var number = $(this).closest('.ge_repeater').find('.item:not(.d-none)').length;
  newItem.find('.ge_number .wrapper').html(number + ".");
  

  // reinit components
  jQuery('[data-toggle="tooltip"]').tooltip();
  init_select();

});

// remove repeater element
jQuery(document).on('click', '.ge_remove_repeater_item:not(.disabled)' , function (e) {

  jQuery('[data-toggle="tooltip"]').tooltip('hide');
  $(this).closest('.ge_repeater .item').remove();

});

// file upload
$(document).ready(function(){

  window.form_files = [];

  $('form').each(function(){

    var id = $(this).attr('id');
    form_files[id] = [];

    $(this).find('.file input').each(function(){

      var label = $(this).attr('data-label');
      var name = $(this).attr('name');
    
      var file = $(this).filepond({
        server: {
            process: {
              url: ge.fileupload,
            },
            revert: null,
            restore: null,
            fetch: null,
        },
        labelIdle: label,
        instantUpload: false,
        labelFileLoading: "Nahrávam",
        labelFileProcessing: "Odosielam",
        labelFileProcessingComplete: "Odielanie dokončené",
        labelTapToCancel: "Kliknite pre zrušenie"
      });

      if(typeof(form_files[id]) != 'object'){
        form_files[id] = {};
      }
      form_files[id][name] = file;

    });

  });

});



// WEBPACK FOOTER //
// ./assets/js/forms.js